export const apiEndpoints = {
  HealingStory: {
    Public: {
      getHealingStoryClinic: '/HealingStories/gethealingstoryclinic',
      getHealingStoryDoctor: '/HealingStories/gethealingstorydoctor',
    },
    Admin: {
      addHealingStory: '/HealingStories/addhealingstory',
      listHealingStory: '/HealingStories/getallhealingstory',
      deleteHealingStory:'/HealingStories/deletehealingstory',
      updateHealingStory:'/HealingStories/updatehealingstory',
    }
  },
  AppointmentForm: {
    Public: {
      addClinicAppointment: '/Appointment/addclinicappointment',
      addDoctorAppointment: '/Appointment/adddoctorappointment',
      addConsultAppointment: '/Appointment/addnewappointment',
    },
    Admin: {
      getClinicAppointment: '/Appointment/getclinicappointment',
      getDoctorAppointment: '/Appointment/getdoctorappointment',
      getConsultAppointment: '/Appointment/getAppointment',
    }
  },
  Blogs: {
    Admin: {
      blogAdd: "/Modules/adddiseases",
      blogUpdate: "/Modules/updatediseases",
    },
    Public: {
      blogList: "/Modules/getmodulelist",
      blogListById: "/Modules/getmodulebyid",
      blogDelete: "/Modules/deletemodule",
      blogListByName: "/Modules/getmodulebyname",
      blogListBySlug: "/Modules/getmodulebyslug",
    }
  },
  Doctors: {
    Public: {
      alldoctorList: '/Clinic/getdoctorlist',
      getDoctorById: '/Clinic/getdoctorbyId',
      getDoctorByName: '/Clinic/getdoctorbyname',
      getDoctorListByClinicId : '/Clinic/getdoctorlistbyclinicid',
    },
    Admin: {
      addDoctor: '/Doctors/adddoctor',
      updateDoctor: '/Doctors/updatedoctor',
      deleteDoctor: '/Doctors/deletedoctor',
      listDoctor: '/Doctors/getdoctorlist',
    }
  },
  Clinic: {
    Public: {
      allClinicList: '/ClinicCenter/getcliniccenterlist',
      getClinicById: '/Clinic/getcliniccenterbyId',
      getClinicByName: '/Clinic/getcliniccenterbyname',
    },
    Admin: {
      addClinic: '/ClinicCenter/addcliniccenter',
    }
  },
  HerbsFood: {
    Public: {
      allHerbsFoodList: '/Modules/Getherbsfood',
      getHerbsFoodById: '/Modules/Getherbsfoodbyid',
    },
    Admin: {
      addHerbsFood: '/Modules/addherbsfood',
    }
  },
  VideoBlog: {
    Public: {
      allVideoBlogList: '/Modules/getvideos',
    },
    Admin: {
      addVideoBlog: '/Modules/addvideos',
    }
  },
  MedicineBlog: {
    Public: {
      allMedicineBlogList: '/Modules/getmedicine',
      getMedicineBlogById: '/Modules/getmedicinebyid',
    },
    Admin: {
      addMedicineBlog: '/Modules/addmedicine',
      updateMedicineBlog: '/Modules/updatemedicine',
    }
  },
  LoginForm: '/Auth/Login',
  clinicBanner: '/Clinic/getclinicbanner', // Banner for home page
  allDiseaseList: '/Clinic/getdisease', // Consult Doctor By Concern Area for home page
  getExpertByDiseaseById: '/Clinic/getdiseasebyexperts', // All doctor list for Concern Area
  getExpertByDiseaseByName: '/Clinic/getdiseasedoctorbyname', // All doctor list for Concern Area By Name
  allHealingStoriesList: '/Clinic/gethealingstories', // Healing stories for page
  getClinicDoctor: '/Clinic/getdoctordetails', // Get Clinic by ID Doctor details
};
